export default {
    methods: {
        getSharePath (path) {
            const { detailParam } = this.$route.query
            if (detailParam) {
                return `/building?${decodeURIComponent(detailParam)}&sub_page=${encodeURIComponent(path)}`
            }
            return path
        }
    }
}